import Text from '../../atoms/Text';

interface IChangeCellProps {
  change: number;
  textSize: number;
}

const ChangeCell = ({ change, textSize }: IChangeCellProps) => {
  if (change > 0) {
    return (
      <Text size={textSize} className='text--green-600'>
        +{change}%
      </Text>
    );
  }

  if (change < 0) {
    return (
      <Text size={textSize} className='text--red-600'>
        {change}%
      </Text>
    );
  }

  return (
    <Text size={textSize} className='text--grey-400'>
      0.0%
    </Text>
  );
};

export default ChangeCell;
